import {Model} from './model';

export class VineaLocation implements Model {
  id: number;
  name: string;
  meta: {
    capacity_count: number,
    employee_count: number,
    entities_count: number,
    female_entities_count: number,
    group_count: number,
    male_entities_count: number,
  };
  created_at: number;

  constructor(data?) {
    if (data != null) {
      this.fill(data);
    }
  }

  public fill(data) {
    this.id         = data['id'];
    this.name       = data['name'];
    this.meta       = data['meta'];
    this.created_at = data['created_at'];
  }

  public serialize() {
    return this;
  }

}
